import tinycolor from "tinycolor2";

// Brightens `base` by `amount` but caps the result at `maxBrightness` (0-255).
// When the naive brighten would blow out to near-white, falls back to a
// proportional mix with white so the color stays visually distinct.
export function clampBright(base, amount, maxBrightness) {
  const candidate = base.clone().brighten(amount);
  if (candidate.getBrightness() > maxBrightness) {
    const ratio = Math.round((maxBrightness / 255) * 100);
    return tinycolor
      .mix("#ffffff", base.toHexString(), 100 - ratio)
      .toHexString();
  }
  return candidate.toHexString();
}

export function resolveColors(primaryColor) {
  const base = tinycolor(primaryColor);

  if (base.isLight()) {
    const bg = base.toHexString();
    const text = base.clone().darken(62).toHexString();
    const hoverBg = base.clone().darken(10).toHexString();
    return {
      bg,
      text,
      hoverBg,
      hoverText: text,
      darkVariant: text,
      lightVariant: bg,
    };
  } else {
    const bg = clampBright(base, 80, 240);
    const text = base.toHexString();
    const hoverBg = clampBright(base, 70, 235);
    return {
      bg,
      text,
      hoverBg,
      hoverText: text,
      darkVariant: text,
      lightVariant: bg,
    };
  }
}
